/** Format a review rating to 2 decimal places (e.g. 8.5 → "8.50"). */
export function formatRating(rating: number | string | null | undefined): string {
  const n = typeof rating === 'number' ? rating : parseFloat(String(rating ?? ''));
  if (Number.isNaN(n)) return '0.00';
  return n.toFixed(2);
}

/** Round a rating to 2 decimal places as a number. */
export function roundRating(rating: number): number {
  return Math.round(rating * 100) / 100;
}
